import { createFileRoute, redirect } from '@tanstack/react-router'
import { hasGrant } from '@/lib/me'

/**
 * `/accounting/transfers/new` — the bank transfer entry screen.
 */
export const Route = createFileRoute('/_authenticated/accounting/transfers/new')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_bank.create')) {
      throw redirect({ to: '/accounting' })
    }
    throw redirect({ to: '/accounting/bank-accounts' })
  },
  component: () => null,
})
